
(function($, window, document) {

	// The $ is now locally scoped 

	// Listen for the jQuery ready event on the document
	$(function() { });

	

	// $('.bp-highlight-slick').slick({
	// 	dots: true,
	// 	speed: 300,
	// 	infinite: true,
	// 	autoplay: false,
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	centerMode: false,
	// 	arrows: true,
	// 	prevArrow: '<span class="slick-prev icon-arrow-left"></span>',
	// 	nextArrow: '<span class="slick-next icon-arrow-right"></span>',
	// 	focusOnSelect: true,
	//     autoplaySpeed: 6000,
	//     // asNavFor: '.lsi-property-slick-nav',
	// });

	$('.bp-home-news-slick').slick({
		dots: false,
		speed: 300,
		infinite: true,
		autoplay: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: false,
		arrows: true,
		prevArrow: '<span class="slick-prev icon-custom-arrow-left"></span>',
		nextArrow: '<span class="slick-next icon-custom-arrow-right"></span>',
		focusOnSelect: true,
	    autoplaySpeed: 10000,
	    // asNavFor: '.lsi-property-slick-nav',
	    responsive: [
		    {
			    breakpoint: 998,
			    settings: {
			        slidesToShow: 2,
			    }
		    },
		    {
			    breakpoint: 767,
			    settings: {
			        slidesToShow: 1,
			    }
		    }
    	]
	});


	$('.bp-shop-dish-slick').each(function(index, el) {

		let container = $(el);

		container.slick({
			dots: false,
			infinite: true,
			autoplay: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			centerMode: true,
			centerPadding: '0px',
			arrows: false,
			prevArrow: '<span class="slick-prev icon-custom-arrow-left"></span>',
			nextArrow: '<span class="slick-next icon-custom-arrow-right"></span>',
			focusOnSelect: true,
		    asNavFor: '.bp-shop-dish-slick-nav',
		});
		container.find('.slick-track').lightGallery({
            selector: '.slick-slide:not(.slick-cloned) a',
            download: false,
            addClass: 'lg-projects-item',
            thumbnail: true,
        });


    	let img = container.find('.slick-track .slick-slide a img');
       	img.css('max-height', (container.width() * 0.8));
       	setTimeout(function(){
        	img.css('max-height', (container.width() * 0.8));
       	},200)
        window.addEventListener('resize', function(event){
        	img.css('max-height', (container.width() * 0.8));
        });
	});
	// $('.bp-shop-dish-slick').slick({
	// 	dots: false,
	// 	infinite: true,
	// 	autoplay: false,
	// 	slidesToShow: 1,
	// 	slidesToScroll: 1,
	// 	centerMode: true,
	// 	centerPadding: '0px',
	// 	arrows: false,
	// 	prevArrow: '<span class="slick-prev icon-custom-arrow-left"></span>',
	// 	nextArrow: '<span class="slick-next icon-custom-arrow-right"></span>',
	// 	focusOnSelect: true,
	//     asNavFor: '.bp-shop-dish-slick-nav',
	// });

	$('.bp-shop-dish-slick-nav').slick({
		dots: false,
		infinite: true,
		autoplay: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: '0px',
		arrows: false,
		prevArrow: '<span class="slick-prev icon-custom-arrow-left"></span>',
		nextArrow: '<span class="slick-next icon-custom-arrow-right"></span>',
		focusOnSelect: true,
	    asNavFor: '.bp-shop-dish-slick',
	});


	$('.bp-shop-slider').slick({
		dots: true,
		speed: 300,
		infinite: true,
		autoplay: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		arrows: false,
		prevArrow: '<span class="slick-prev icon-custom-arrow-left"></span>',
		nextArrow: '<span class="slick-next icon-custom-arrow-right"></span>',
		focusOnSelect: true,
	    autoplaySpeed: 12000,
	    // asNavFor: '.lsi-property-slick-nav',
	    
	});


	$('.bp-highlight-home-section.-slick').slick({
		dots: false,
		speed: 300,
		infinite: true,
		// autoplay: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: false,
		arrows: true,
		prevArrow: '<span class="slick-prev">&#10140;</span>',
		nextArrow: '<span class="slick-next">&#10140;</span>',
		focusOnSelect: true,
	    autoplaySpeed: 12000,
	    // asNavFor: '.lsi-property-slick-nav',
	    
	});



	window.addEventListener('resize', function(event){



	});
	

    
}(window.jQuery, window, document));